import React from 'react';

import { Route } from 'react-router';

import PhoneAgentSettings from './PhoneAgent/PhoneAgentSettings';

type Props = { path: string };

const PhoneAgentRoutes: React.FC<Props> = ({ path }) => {
  return <Route exact path={`${path}/phone-agent`} component={PhoneAgentSettings} />;
};

export default PhoneAgentRoutes;
